import Joi from '@hapi/joi'

export const QRtagschemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    routeID: Joi.number().invalid(0).required().label("Route").messages({
        "any.invalid": `Select Route`,
        "any.required": `Route required`
    }),

    isActive: Joi.boolean().label("Active"),


    
}

